import { mapActions, mapState } from 'vuex';
const MEGFELELO_HITEL_TA = 'MEGFELELO_HITEL';
const PRODUCT_NAME_TA = 'TERMEKNEV';
const INSTALLMENT_TA = 'TORLESZTORESZLET';
const INTEREST_TA = 'KAMAT';
const APR_TA = 'THM';
const INTEREST_PERIOD_TEXT_TA = 'KAMATPERIODUS';

export const openDetailsModalSendTaMixin = {
	methods: {
		createAndSendTa(product) {
			let taData = {
				eventType: MEGFELELO_HITEL_TA + '_' + this.layoutCategory,
				dataElements: [
					{
						name: PRODUCT_NAME_TA,
						value: product.officialName
					},
					{
						name: INSTALLMENT_TA,
						value: product.installment
					},
					{
						name: INTEREST_TA,
						value: product.interest
					},
					{
						name: APR_TA,
						value: product.thm
					},
					{
						name: INTEREST_PERIOD_TEXT_TA,
						value: product.interestPeriodText
					}
				]
			};
			this.sendTa(taData);
		},
		...mapActions('lahi', ['sendTa'])
	},
	computed: {
		...mapState('lahi', ['layoutCategory'])
	}
};
